// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__3i9Qg","title":"Profile_title__3UJb3","dashed":"Profile_dashed__169F9"};